function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeWidth: "2",
  stroke: "#000",
  d: "M20 4.236L4.057 15.82l6.09 18.742h19.707l6.09-18.742L20 4.236z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: "2",
  fill: "none",
  strokeDasharray: "4",
  stroke: "#000",
  d: "M10 35l18-25"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "11",
  cy: "34",
  r: "2.5"
}), /*#__PURE__*/React.createElement("circle", {
  cy: "10.002",
  cx: "27.594",
  r: "2.5"
})));